import type React from 'react';

import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@change/ds-core-ui';

import { useI18n } from '@change-corgi/core-react/i18n';

import { useOverwritePaymentMethodConfirmationModal } from './hooks/useOverwritePaymentMethodConfirmationModal';

export const OverwritePaymentMethodConfirmationModal: React.FC<EmptyProps> = () => {
	const { translate } = useI18n();
	const {
		data: { title, text, cancelLabel, confirmLabel, showOverwritePaymentMethodModal },
		actions: { confirmPaymentMethodOverwrite, cancelPaymentMethodOverwrite },
	} = useOverwritePaymentMethodConfirmationModal();

	return (
		<Modal
			isOpen={showOverwritePaymentMethodModal}
			aria-label="Overwrite Payment Method Confirmation Modal"
			onClose={cancelPaymentMethodOverwrite}
			closeButtonAriaLabel={translate('corgi.components.modal.close_button')}
			className="z-999 *:min-h-[100px]!"
			size="small"
		>
			<ModalHeader
				title={
					<Text size="x-small" className="font-bold">
						{title}
					</Text>
				}
			/>
			<ModalBody>
				<div className="mx-auto flex flex-col items-center gap-4">
					<Text size="medium">{text}</Text>
				</div>
			</ModalBody>
			<ModalFooter>
				<div className="flex w-full flex-col gap-4">
					<Button
						onClick={confirmPaymentMethodOverwrite}
						data-qa="payment-overwrite-method-button-confirm-yes"
						variant="primary"
						size="small"
					>
						{confirmLabel}
					</Button>
					<Button
						onClick={cancelPaymentMethodOverwrite}
						data-qa="payment-overwrite-method-button-confirm-no"
						variant="secondary"
						size="small"
					>
						{cancelLabel}
					</Button>
				</div>
			</ModalFooter>
		</Modal>
	);
};
